import React from "react";
import SupportOptions from "./sections/SupportOptions";
import PrePlanOptions from "./sections/PrePlanOptions";
import HomeMenuItem from "./sections/HomeMenuItem";
import PostPlanOptions from "./sections/PostPlanOptions";
import MenuHeader from "./sections/MenuHeader";
import {LanguageSwitcher} from "~/components/LanguageSwitcher";
import ExternalLinkOptions from "./sections/ExternalLinksOptions";

const ConsumerMenuContent = () => {
  return (
    <>
      <MenuHeader />
      <HomeMenuItem />
      <PostPlanOptions />
      <PrePlanOptions />
      <SupportOptions />
      <ExternalLinkOptions />
      <LanguageSwitcher />
    </>
  );
};

export default ConsumerMenuContent;
